export { default as ReCaptchaText } from './ReCaptchaText';
